<small class="debug">{{ me }}</small>

<div mat-dialog-content>
  <div class="content-wrapper">
    <a matSuffix (click)="onClose()" class="close">
      <!-- <mat-icon>Close</mat-icon> -->
    </a>
    <div class="lightbox-div" #lightboxDiv>
      <img [src]="(resourceUrl)" loading="lazy" onerror="src='./assets/images/no_image.png'" />
    </div>
  </div>
</div>
